<script setup>
let initialRenderStore = useInitialRenderStore()
let route = useRoute()

useHead({
  htmlAttrs: {
    class: ['project'],
  },
})

let { data: site, pending: sitePending } = await useWordpressData('wp-remote/site')
let {
  data: project,
  pending: projectPending,
  error,
} = await useWordpressData(`wp-remote/project/${route.params.slug}`)

let pending = logicOr(sitePending, projectPending)

watch(
  error,
  value => {
    if (value) {
      showError(value)

      // We don't want to fail silently in production
      if (import.meta.env.MODE === 'production') {
        throw value
      }
    } else {
      clearError()
    }
  },
  { immediate: true },
)

let progressStore = useProgressStore()

useHead({
  title: computed(() => project.value?.title ?? 'Projekt'),
})

useSEO(site, project)

let loadedHeroImage = ref(false)

progressStore.track(useProgress(loadedHeroImage, 'work page hero image'))

until(loadedHeroImage)
  .toBe(true)
  .then(() => {
    // Notify globally to make transitions from the work slider possible
    window.dispatchEvent(new CustomEvent('moduleplus:project-loaded'))
  })
</script>

<template>
  <Layout v-if="!pending && project">
    <WorkHero :project="project" v-model:image-loaded="loadedHeroImage" />
    <WpceDocument :tree="project.document" />

    <div class="page-section">
      <div class="container">
        <PrevNext :previous="`/work/${project.previous}`" :next="`/work/${project.next}`" v-enter />
      </div>
    </div>
  </Layout>
  <Transition name="fade">
    <LoadingOverlay v-if="initialRenderStore.isInitial && pending" />
  </Transition>
</template>

<style lang="scss" scoped>
@keyframes fade-in {
  to {
    opacity: 1;
  }
}
</style>
